// extracted by mini-css-extract-plugin
export var cardHeader = "_rk-0";
export var reorderHandle = "_rk-3";
export var titleArea = "_rk-1";
export var titleAreaWithHandle = "_rk-2";